import http from "../helpers/http";
import db from "../helpers/db";
import date from "../helpers/date";

export default {
    namespaced: true,
    state: {
        schedule: {
            patient: db.toSchedule.patient,
            availabilityTime: db.toSchedule.availabilityTime,
            paymentMethod: db.toSchedule.paymentMethod,
            paymentType: db.toSchedule.paymentType,
            insurance: db.toSchedule.insurance,
            cancelingPolicy: db.toSchedule.cancelingPolicy,
            professional: db.toSchedule.professional,
            specialty: db.toSchedule.specialty,
            city: db.toSchedule.city,
            exams: db.toSchedule.exams,
            place: db.toSchedule.placeSchedule,
            plan: db.toSchedule.plan,
        },
        cities: [],
        specialties: [],
        paymentMethods: [],
        paymentTypes: [],
        insurances: [],
        professionals: [],
        patients: [],
        cancelingPolicies: [],
        pixData: db.toSchedule.pixData,
        scheduleType: db.toSchedule.scheduleType, // DEFAULT, PROFESSIONAL, PLACE
        attendanceType: db.toSchedule.attendanceType, // ONLINE, ONSITE, EXAM, EXAM-LAB
        specGroup: db.toSchedule.specGroup,
        place: db.toSchedule.place,
        savedCreditCards: [],
    },
    mutations: {
        setPlace(state, place) {
            state.place = db.toSchedule.storePlace(place);
        },
        setPlaceSchedule(state, place) {
            state.place = db.toSchedule.storePlaceSchedule(place);
        },
        setScheduleType(state, type) {
            state.scheduleType = db.toSchedule.storeScheduleType(type);
        },
        setAttendanceType(state, type) {
            state.attendanceType = db.toSchedule.storeAttendanceType(type);
        },
        setSpecGroup(state, specGroup) {
            state.specGroup = db.toSchedule.storeSpecGroup(specGroup);
        },
        setCities(state, cities) {
            state.cities = cities;
        },
        selectCity(state, city) {
            state.schedule.city = db.toSchedule.storeCity(city);
        },
        setExams(state, exams) {
            state.schedule.exams = db.toSchedule.storeExams(exams);
        },
        setSpecialties(state, specialties) {
            state.specialties = specialties;
        },
        selectSpecialty(state, specialty) {
            state.schedule.specialty = db.toSchedule.storeSpecialty(specialty);
        },
        setPaymentMethods(state, paymentMethods) {
            state.paymentMethods = paymentMethods;
        },
        selectPaymentMethod(state, paymentMethod) {
            state.schedule.paymentMethod = db.toSchedule.storePaymentMethod(paymentMethod);
            state.schedule.insurance = db.toSchedule.storeInsurance(null);
            state.schedule.cancelingPolicy = db.toSchedule.storeCancelingPolicy(null);
        },
        setPaymentTypes(state, paymentTypes) {
            state.paymentTypes = paymentTypes;
        },
        selectPaymentType(state, paymentType) {
            state.schedule.paymentType = db.toSchedule.storePaymentType(paymentType);
            state.schedule.paymentMethod = db.toSchedule.storePaymentMethod(null);
            state.schedule.insurance = db.toSchedule.storeInsurance(null);
            state.schedule.cancelingPolicy = db.toSchedule.storeCancelingPolicy(null);
        },
        selectPlan(state, plan) {
            state.schedule.plan = db.toSchedule.storePlan(plan);
            state.schedule.paymentMethod = db.toSchedule.storePaymentMethod(null);
            state.schedule.insurance = db.toSchedule.storeInsurance(null);
            state.schedule.cancelingPolicy = db.toSchedule.storeCancelingPolicy(null);
        },
        setInsurances(state, insurances) {
            state.insurances = insurances;
        },
        selectInsurance(state, insurance) {
            state.schedule.insurance = db.toSchedule.storeInsurance(insurance);
        },
        setProfessionals(state, professionals) {
            state.professionals = professionals;
        },
        updateNextAvailabilityFromProfessional(state, param) {
            let availability = param.availability;
            let indexProf = state.professionals.findIndex((prof) => prof.id_prof === param.professional.id_prof);

            let currentAvailabilityFromProf = state.professionals[indexProf].availability_dates;
            let currentLastDateFromProf     = currentAvailabilityFromProf[currentAvailabilityFromProf.length -1].available_date_patient;
            let newLastDateFromProf         = availability[availability.length -1].available_date_patient;

            if (date(newLastDateFromProf) > date(currentLastDateFromProf))
                state.professionals[indexProf].availability_dates = availability;
        },
        updatePreviousAvailabilityFromProfessional(state, param) {
            let availability = param.availability;
            let indexProf = state.professionals.findIndex((prof) => prof.id_prof === param.professional.id_prof);

            let currentAvailabilityFromProf = state.professionals[indexProf].availability_dates;
            let currentFirstDateFromProf    = currentAvailabilityFromProf[0].available_date_patient;
            let newFirstDateFromProf        = availability[0].available_date_patient;

            if (date(newFirstDateFromProf) < date(currentFirstDateFromProf))
                state.professionals[indexProf].availability_dates = availability;
        },
        selectAvailability(state, availability) {
            state.schedule.professional = db.toSchedule.storeProfessional(availability.professional);
            state.schedule.availabilityTime = db.toSchedule.storeAvailabilityTime(availability.availabilityTime);
        },
        setPatients(state, patients) {
            state.patients = patients;
        },
        selectPatient(state, patient) {
            state.schedule.patient = db.toSchedule.storePatient(patient);
        },
        setCancelingPolicies(state, cancelingPolicies) {
            state.cancelingPolicies = cancelingPolicies;
        },
        setPixData(state, pixData) {
            state.pixData = db.toSchedule.storePixData(pixData);
        },
        /** For schedule checkout page (card payment via link): set minimal context so gateway components can render. */
        setCheckoutCardContext(state, { card_administrator_code }) {
            state.schedule.cancelingPolicy = { card_administrator_code, supports_tokenization: false };
            if (!state.schedule.availabilityTime) state.schedule.availabilityTime = {};
            state.schedule.availabilityTime.avail_online = false;
            if (!state.schedule.paymentMethod) state.schedule.paymentMethod = {};
            state.schedule.paymentMethod.is_credit_card = true;
        },
        selectCancelingPolicy(state, cancelingPolicy) {
            state.schedule.cancelingPolicy = db.toSchedule.storeCancelingPolicy(cancelingPolicy);
        },
        setSavedCreditCards(state, cards) {
            state.savedCreditCards = cards;
        },
        clearAll(state) {
            state.schedule.city = db.toSchedule.storeCity(null);
            state.schedule.specialty = db.toSchedule.storeSpecialty(null);
            state.schedule.insurance = db.toSchedule.storeInsurance(null);
            state.schedule.paymentType = db.toSchedule.storePaymentType(null);
            state.schedule.paymentMethod = db.toSchedule.storePaymentMethod(null);
            state.schedule.professional = db.toSchedule.storeProfessional(null);
            state.schedule.availabilityTime = db.toSchedule.storeAvailabilityTime(null);
            state.schedule.patient = db.toSchedule.storePatient(null);
            state.schedule.cancelingPolicy = db.toSchedule.storeCancelingPolicy(null);
            state.pixData = db.toSchedule.storePixData(null);
            state.place = db.toSchedule.storePlace(null);
            state.schedule.place = db.toSchedule.storePlaceSchedule(null);
            state.scheduleType = db.toSchedule.storeScheduleType(null);
            state.attendanceType = db.toSchedule.storeAttendanceType(null);
            state.specGroup = db.toSchedule.storeSpecGroup(null);
            state.exams = db.toSchedule.storeExams(null);
            state.schedule.plan = db.toSchedule.storePlan(null);
        }
    },
    actions: {
        getExamCities(context) {
            http.get('/schedule/exams/cities').then((cities) => {
                context.commit('setCities', cities.data)
            });
        },
        getCitiesSupported(context) {
            http.get('/schedule/cities/supported', {
                params: {
                    kind_exam: context.state.attendanceType.substring(0,4) === 'EXAM',
                }
            }).then((cities) => {
                context.commit('setCities', cities.data)
            });
        },
        getSpecialties(context, param) {
            http.get('/schedule/specialties', {
                params: {
                    id_city: context.state.schedule.city?.id_city,
                    id_place: context.state.place?.id_place,
                    kind_exam: context.state.attendanceType.substring(0,4) === 'EXAM',
                    id_spec_group: param?.id_spec_group,
                }
            }).then((specialties) => {
                context.commit('setSpecialties', specialties.data)
            });
        },
        getPaymentMethods(context) {
            http.get('/schedule/payment-methods', {
                params: {
                    id_city: context.state.schedule.city?.id_city,
                    id_spec: context.state.schedule.specialty.id_spec,
                    id_place: context.state.place?.id_place,
                }
            }).then((paymentMethods) => {
                context.commit('setPaymentMethods', paymentMethods.data)
            });
        },
        getPaymentTypes(context) {
            http.get('/schedule/payment-types', {
                params: {
                    id_city: context.state.schedule.city?.id_city,
                    id_spec: context.state.schedule.specialty.id_spec,
                    id_place: context.state.place?.id_place,
                }
            }).then((paymentTypes) => {
                context.commit('setPaymentTypes', paymentTypes.data)
            });
        },
        getInsurances(context) {
            http.get('/schedule/insurances', {
                params: {
                    id_city: context.state.schedule.city?.id_city,
                    id_spec: context.state.schedule.specialty.id_spec,
                    id_paymeth: context.state.schedule.paymentMethod?.id_paymeth,
                    id_prof: context.state.schedule.professional?.id_prof,
                    id_place: context.state.place?.id_place,
                }
            }).then((insurances) => {
                context.commit('setInsurances', insurances.data)
            });
        },
        getProfessionals(context, param) {
            return http.get('/schedule/professionals', {
                params: {
                    id_city: context.state.schedule.city?.id_city,
                    id_spec: context.state.schedule.specialty.id_spec,
                    id_paymeth: context.state.schedule.paymentMethod.id_paymeth,
                    id_insurance: context.state.schedule.insurance?.id_insurance,
                    id_place: context.state.place?.id_place,
                    id_plan: context.state.schedule.plan?.id_plan,
                    with_availability: true,
                    start_end_days: param.start_end_days,
                }
            }).then((professionals) => {
                context.commit('setProfessionals', professionals.data);
                return professionals;
            });
        },
        paginateAvailabilityProfessional(context, param) {
            let professional = param.professional;
            let startDate    = param.start_date;
            let startEndDays = param.start_end_days;
            return http.get('/schedule/availabilities/dates-times', {
                params: {
                    id_place: professional.id_place,
                    id_prof: professional.id_prof,
                    id_spec: context.state.schedule.specialty.id_spec,
                    id_city: context.state.schedule.city?.id_city,
                    id_paymeth: context.state.schedule.paymentMethod.id_paymeth,
                    id_insurance: context.state.schedule.insurance?.id_insurance,
                    id_plan: context.state.schedule.plan?.id_plan,
                    start_date: startDate,
                    start_end_days: startEndDays,
                }
            });
        },
        paginatePreviousAvailabilityProfessional(context, param) {
            return context.dispatch('paginateAvailabilityProfessional', param).then((response) => {
                context.commit('updatePreviousAvailabilityFromProfessional', {
                    professional: param.professional,
                    availability: response.data,
                });

                return response;
            });
        },
        paginateNextAvailabilityProfessional(context, param) {
            return context.dispatch('paginateAvailabilityProfessional', param).then((response) => {
                context.commit('updateNextAvailabilityFromProfessional', {
                    professional: param.professional,
                    availability: response.data,
                });

                return response;
            });
        },
        getPatients(context) {
            let userAuth = context.getters.userAuth;
            http.get(`/users/${userAuth.id_user}/patients`).then((patients) => {
                context.commit('setPatients', patients.data)
            });
        },
        getCancelingPolicies(context) {
            http.get('/schedule/canceling-policies', {
                params: {
                    id_place_session: context.state.place?.id_place,
                    id_place: context.state.schedule.professional.id_place,
                    id_spec: context.state.schedule.specialty.id_spec,
                    id_prof: context.state.schedule.professional.id_prof,
                    id_plan: context.state.schedule.plan?.id_plan,
                    sched_date: context.state.schedule.availabilityTime.available_date,
                    sched_time: context.state.schedule.availabilityTime.available_time,
                }
            }).then((cancelingPolicies) => {
                context.commit('setCancelingPolicies', cancelingPolicies.data)
            });
        },
        scheduleAppointment(context, schedParams) {
            let parameterCreditCard = schedParams.creditCard;
            let userAddress = schedParams.userAddress;
            let files = schedParams.files || [];
            let schedule = context.state.schedule;
            let userAuth = context.getters.userAuth;
            
            const formData = new FormData();
            
            formData.append('sched_date', schedule.availabilityTime.available_date);
            formData.append('sched_time', schedule.availabilityTime.available_time);
            formData.append('id_patient', schedule.patient.id_patient);
            formData.append('id_user', userAuth.id_user);
            formData.append('id_avail', schedule.availabilityTime.id_avail);
            formData.append('id_place', schedule.professional.id_place);
            if (schedule.availabilityTime?.id_place_location) {
                formData.append('id_place_location', schedule.availabilityTime.id_place_location);
            }
            formData.append('id_prof', schedule.professional.id_prof);
            formData.append('id_spec', schedule.specialty.id_spec);
            formData.append('id_city', schedule.city?.id_city || '');
            formData.append('id_visit_value', schedule.cancelingPolicy?.id_visit_value || '');
            formData.append('id_paymeth', schedule.paymentMethod.id_paymeth);
            formData.append('id_insurance', schedule.insurance?.id_insurance || '');
            formData.append('id_spec_group', context.state.specGroup?.id_spec_group || '');
            formData.append('sched_by', 'US');
            formData.append('sched_online', schedule.availabilityTime.avail_online);

            Object.entries(userAddress).forEach(([key, value]) => {
                formData.append(
                    `user_address[${key}]`,
                    value === "null" || value === null || value === undefined ? "" : value
                );
            });

            formData.append('sched_recommended', !!schedule.professional.sched_recommended);
            formData.append('id_plan', schedule.plan?.id_plan ?? '');

            if (schedParams.creditCardTokenId) {
                formData.append('credit_card_token_id', schedParams.creditCardTokenId);
                formData.append('installments', parameterCreditCard?.installments || '');
            } else if (parameterCreditCard) {
                formData.append('installments', parameterCreditCard.installments || '');
                formData.append('gateway_payment_credit_card_data', JSON.stringify(parameterCreditCard));
                
                if (schedParams.saveCard) {
                    formData.append('save_card', 'true');
                    if (schedParams.cardNickname) {
                        formData.append('card_nickname', schedParams.cardNickname);
                    }
                }
            }

            files.forEach((fileData, index) => {
                formData.append(`files[${index}][name]`, fileData.name);
                formData.append(`files[${index}][file]`, fileData.file);
            });

            return http.post('/schedule/appointment', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
                if (schedule.paymentMethod.is_pix) {
                    context.commit('setPixData', response.data);
                    return response;
                } else {
                    context.commit('clearAll');
                    return response;
                }
            });
        },
        getSavedCreditCards(context, cardAdministratorCode) {
            let userAuth = context.getters.userAuth;
            if (!userAuth || !userAuth.id_user) {
                return Promise.resolve([]);
            }
            if (!cardAdministratorCode) {
                return Promise.resolve([]);
            }
            return http.get(`/users/${userAuth.id_user}/credit-card-tokens`, {
                params: { card_administrator_code: cardAdministratorCode }
            }).then((response) => {
                context.commit('setSavedCreditCards', response.data || []);
                return response.data || [];
            }).catch(() => {
                context.commit('setSavedCreditCards', []);
                return [];
            });
        },
        scheduleExam(context, schedParams) {
            let parameterCreditCard = schedParams.creditCard;
            let userAddress = schedParams.userAddress;
            let schedule = context.state.schedule;
            let userAuth = context.getters.userAuth;
            let param = {
                id_patient: schedule.patient.id_patient,
                id_user: userAuth.id_user,
                id_place: schedule.professional.id_place,
                id_city: schedule.city?.id_city,
                id_paymeth: schedule.paymentMethod.id_paymeth,
                id_insurance: schedule.insurance?.id_insurance,
                id_spec_group: context.state.specGroup?.id_spec_group,
                items: schedule.exams.map((exam) => ({id_place: schedule.professional.id_place, ...exam})),
                budget_by: 'patient',
                budget_obs: schedParams.budget_obs,
                budget_origin: 'web',
                budget_type: context.state.attendanceType,
                user_address: userAddress,
                installments: parameterCreditCard?.installments,
                file: schedParams.file,
            };

            if (schedParams.creditCardTokenId) {
                param.credit_card_token_id = schedParams.creditCardTokenId;
            } else if (parameterCreditCard) {
                param.gateway_payment_credit_card_data = parameterCreditCard;
                
                if (schedParams.saveCard) {
                    param.save_card = true;
                    if (schedParams.cardNickname) {
                        param.card_nickname = schedParams.cardNickname;
                    }
                }
            }

            return http.post('/schedule/exams', param).then((response) => {
                if (schedule.paymentMethod.is_pix) {
                    context.commit('setPixData', response.data);

                    return response;
                } else {
                    context.commit('clearAll');
                    return response;
                }
            });
        }
    },
    getters: {
        userAuth(state, _, rootState) {
            return rootState.auth.user;
        },
        tokenAuth(state, _, rootState) {
            return rootState.auth.user;
        },
    }
};